// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$String = require("rescript/lib/js/string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");

var reEmberId = new RegExp("ember\\d+");

var reUUID = new RegExp($$String.concat("-", List.map((function (n) {
                return "\\b[a-fA-F0-9]{" + n + "}";
              }), {
              hd: 8,
              tl: {
                hd: 4,
                tl: {
                  hd: 4,
                  tl: {
                    hd: 4,
                    tl: {
                      hd: 12,
                      tl: /* [] */0
                    }
                  }
                }
              }
            })));

var githubIssueId = new RegExp("^issue_\\d+");

var googleDriveId = new RegExp("^:[\\d|\\w]{2}$");

function isGeneratedId(id) {
  return Belt_Array.some([
              reEmberId,
              reUUID,
              githubIssueId,
              googleDriveId
            ], (function (re) {
                return re.test(id);
              }));
}

exports.reEmberId = reEmberId;
exports.reUUID = reUUID;
exports.githubIssueId = githubIssueId;
exports.googleDriveId = googleDriveId;
exports.isGeneratedId = isGeneratedId;
/* reEmberId Not a pure module */
